// src/pages/ResultPage.js
import React from 'react';

function ResultPage() {
  return (    <main className="container py-4" role="main">
      <div className="card">
        <div className="card-body text-center">
          <h1 className="card-title" id="result-title">Quiz Results</h1>
          <div role="status" aria-live="polite" className="mt-4">
            <p className="h2" aria-labelledby="result-title">Score: Coming Soon</p>
          </div>
          <div className="mt-4">
            <a 
              href="/" 
              className="btn btn-primary me-2"
              role="button"
              aria-label="Return to quiz selection"
            >
              Try Another Quiz
            </a>
            <button 
              className="btn btn-outline-primary"
              aria-label="Review your answers"
              disabled
            >
              Review Answers
            </button>
          </div>
        </div>
      </div>
    </main>
  );
}

export default ResultPage;
